// extracted by mini-css-extract-plugin
module.exports = {"list":"LearningUnitIcons_list","item":"LearningUnitIcons_item"};